module.exports = __webpack_public_path__ + "44dfe8cc676882243911a3197a50169e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Lato-Bold.ttf
// module id = 310
// module chunks = 0